/* jshint esversion: 6 */
import { Share } from '@capacitor/share';
import cordovaToast from './toast';

export default {
    async share (options) {
        if (process.env.CORDOVA) {
            if (cordovaToast && cordovaToast.toast) {
                cordovaToast.toast('Buscando aplicaciones para compartir, espere ...');
            }
            await Share.share(options);
        } else {
            console.error('ERROR: Se llamó al social plugin pero no se encontró');
        }
    }

};



// WEBPACK FOOTER //
// ./src/cordova/socialShare.js